module.exports = __webpack_public_path__ + "static/img/0544_3.87e97b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_3.jpg
// module id = ok7y
// module chunks = 1